import Vue from "vue";
import * as _ from "lodash";

// Translation text files
import translationsEnPro from "@/resources/i18n/en/localizable_pro.json";
import translationsEnColors from "@/resources/i18n/en/localizable_color.json";
import translationsCnPro from "@/resources/i18n/zh_CN/localizable_pro.json";
import translationsCnColors from "@/resources/i18n/zh_CN/localizable_color.json";
import translationsFrPro from "@/resources/i18n/fr/localizable_pro.json";
import translationsFrColors from "@/resources/i18n/fr/localizable_color.json";
import translationsRuPro from "@/resources/i18n/ru/localizable_pro.json";
import translationsRuColors from "@/resources/i18n/ru/localizable_color.json";
import translationsViPro from "@/resources/i18n/vi/localizable_pro.json";
import translationsViColors from "@/resources/i18n/vi/localizable_color.json";

export interface Locale {
  value: string;
  text: string;
}

// TODO convert to ENUM
export const LOCALES: Locale[] = [
  { value: 'en', text: 'English' },
  { value: 'cn', text: '中文' },
  // { value: "ru", text: "Русский" },
  // { value: "fr", text: "Française" },
  // { value: "vi", text: "Việt" },
];

export function localeInit() {
  // Add translations directly to the application
  const translationsEn = _.merge(translationsEnPro, translationsEnColors);
  const translationsCn = _.merge(translationsCnPro, translationsCnColors);
  const translationsFr = _.merge(translationsFrPro, translationsFrColors);
  const translationsRu = _.merge(translationsRuPro, translationsRuColors);
  const translationsVi = _.merge(translationsViPro, translationsViColors);
  Vue.i18n.add("en", translationsEn);
  Vue.i18n.add("cn", translationsCn);
  Vue.i18n.add("fr", translationsFr);
  Vue.i18n.add("ru", translationsRu);
  Vue.i18n.add("vi", translationsVi);

  // Check if user have select locale before
  if (localStorage.getItem("locale")) {
    Vue.i18n.set(localStorage.getItem("locale")!);
  } else {
    switch (navigator.languages[1]) {
    case "en":
      Vue.i18n.set("en");
      break;
    case "zh":
      Vue.i18n.set("cn");
      break;
    case "fr":
      Vue.i18n.set("fr");
      break;
    case "ru":
      Vue.i18n.set("ru");
      break;
    case "vi":
      Vue.i18n.set("vi");
      break;
    default:
      Vue.i18n.set("en");
    }
  }
}

/**
 * Check locale string is valid and supported, return Locale object if valid.
 */
export function localeIsSupported(locale?: string): Locale | undefined {
  return LOCALES.find(el => el.value === locale);
}

/**
 * Cache locale preference on frontend.
 * For logged in user, use `updateUserLocale` mutation to update DB if necessary.
 */
export function saveLocalePreference(locale: Locale) {
  // Update i18n service
  Vue.i18n.set(locale.value);
  // Update localStorage
  localStorage.setItem("locale", locale.value);
}